(function ($) {
    $(document).ready(function () {
        const initializeSliders = function () {
            const getSection = $('.logo-with-carousel');

            if (getSection.length) {
                const logosLarge = $('.logo-with-carousel .wrapper');

                // Destroy any previous instances of Slick only if initialized
                if (logosLarge.hasClass('slick-initialized')) {
                    logosLarge.slick('unslick');
                }

                // Reinitialize the sliders
                logosLarge.slick({
                    dots: false,
                    infinite: true,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 20,
                    adaptiveHeight: true,
                    speed: 8000,
                    cssEase: "linear",
                    centerPadding: "100px",
                    slidesToShow: 4,
                    pauseOnHover: false,

                    responsive: [
                        {
                            breakpoint: 1025,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 3,
                                speed: 9000
                            }
                        },
                        {
                            breakpoint: 595,
                            settings: {
                                slidesToShow: 2,
                                speed: 9000
                            }
                        }
                    ]
                });
            }
        };

        // Debounce function to limit how often resize logic is executed
        let resizeTimer;
        const debounceResize = function (func, delay) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(func, delay);
        };

        // Initialize sliders on document ready
        initializeSliders();

        // Reinitialize sliders on window resize with debounce
        $(window).resize(function () {
            debounceResize(initializeSliders, 250); // 250ms delay for smoothness
        });
    });
})(jQuery);
